import React, { useState, useEffect, useContext, Fragment } from 'react';
import { List, Tag, Spin, Card } from 'antd';
import { Link } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import AuthContext from '../../context/authProvider';
import InvoiceService from '../invoices/services';

import CardEmptyResult from 'components/common/pageComponents/CardEmptyResult';
import { PiReceiptDuotone } from 'react-icons/pi';

const InvoicesDueTodayList = () => {
  const { auth } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [invoicesDueToday, setInvoicesDueToday] = useState([]);

  useEffect(() => {
    fetchInvoicesDueToday();
  }, []);

  const fetchInvoicesDueToday = async () => {
    try {
      const userTimezone = auth?.user?.timezone_name || 'UTC';
      const response = await InvoiceService.getInvoicesDueToday(userTimezone);
      const result = response.data;
      if (result.success) {
        setInvoicesDueToday(result.data);
      }
    } catch (error) {
      console.error('Error fetching invoices due today:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Spin indicator={<LoadingOutlined spin />} />;
  }

  return (
    <Fragment>
      {invoicesDueToday.length > 0 ? (
        <Card size="small">
          <List
            size="small"
            dataSource={invoicesDueToday}
            renderItem={(invoice) => (
              <List.Item>
                <List.Item.Meta
                  title={
                    <Link to={`/invoices/invoice-details/${invoice.id}`}>
                      {`${invoice.sale_number} - Due Today`}
                    </Link>
                  }
                  description={`${invoice.extra?.meta?.description || 'No description'}`}
                />
                <div>
                  <Tag color="orange">${invoice.amount_due}</Tag>
                </div>
              </List.Item>
            )}
          />
        </Card>
      ) : (
        <CardEmptyResult title="No invoices due today" subtitle="There are no invoices due today" icon={<PiReceiptDuotone className="fs-2 text-secondary" />} />
      )}
    </Fragment>
  );
};

export default InvoicesDueTodayList;
